/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Text_To_Audio_Short_Warning_TitleInputs */

const en_dialog_text_to_audio_short_warning_title = /** @type {(inputs: Dialog_Text_To_Audio_Short_Warning_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Very little text entered`)
};

const es_dialog_text_to_audio_short_warning_title = /** @type {(inputs: Dialog_Text_To_Audio_Short_Warning_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se ingresó muy poco texto`)
};

/**
* | output |
* | --- |
* | "Very little text entered" |
*
* @param {Dialog_Text_To_Audio_Short_Warning_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_short_warning_title = /** @type {((inputs?: Dialog_Text_To_Audio_Short_Warning_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Short_Warning_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_short_warning_title(inputs)
	return en_dialog_text_to_audio_short_warning_title(inputs)
});